/** Monthly impact as "$2.1k/mo" or "$910/mo" with the given currency prefix. */
export function formatImpact(v: number | null | undefined, prefix: string): string {
  if (v == null) return '-';
  const abs = Math.abs(Math.round(v));
  if (abs >= 1000) return `${prefix}${(abs / 1000).toFixed(abs >= 10000 ? 0 : 1)}k/mo`;
  return `${prefix}${abs}/mo`;
}
